import React, { Component } from 'react';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

export default class Sponsor extends Component {
  static propTypes = {

  };

  render() {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Sponsor Information
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <TextField
              id="sponsor_name"
              name="sponsor_name"
              label="Name"
              fullWidth
              autoComplete="sName"
              value={this.props.project.sponsor_name}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.sponsor_name}
              helperText={this.props.errores.project.sponsor_name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="sponsor_position"
              name="sponsor_position"
              label="Position"
              fullWidth
              autoComplete="sPosition"
              value={this.props.project.sponsor_position}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.sponsor_position}
              helperText={this.props.errores.project.sponsor_position}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
             <TextField
              id="sponsor_email"
              name="sponsor_email"
              label="E-mail"
              fullWidth
              autoComplete="sMail"
              value={this.props.project.sponsor_email}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.sponsor_email}
              helperText={this.props.errores.project.sponsor_email}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="sponsor_phone"
              name="sponsor_phone"
              label="Telephone"
              fullWidth
              autoComplete="sNumber"
              value={this.props.project.sponsor_phone}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.sponsor_phone}
              helperText={this.props.errores.project.sponsor_phone}
            />
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/Sponsor.js